'use es6';

import { CELL_ATTRIBUTE } from '../constants/dndAreaDomConstants';
export const getComputedMargin = element => {
  if (element) {
    const elementComputedStyles = window.getComputedStyle(element);
    return {
      left: parseInt(elementComputedStyles.marginLeft, 10),
      top: parseInt(elementComputedStyles.marginTop, 10),
      bottom: parseInt(elementComputedStyles.marginBottom, 10),
      right: parseInt(elementComputedStyles.marginRight, 10)
    };
  }
  return {};
};
export const getDndAreaComputedMargin = dndAreaElement => {
  if (dndAreaElement) {
    const computedMargin = getComputedMargin(dndAreaElement);
    const computedMarginKeys = ['bottom', 'left', 'right', 'top'];

    // Don't look for extra margin if it's the top-level body section
    if (dndAreaElement.getAttribute(CELL_ATTRIBUTE) !== 'body_section') {
      // Account for margin on wrappingHTML around layout section
      const addAncestorComputedMargin = element => {
        if (element && !element.classList.contains('row-fluid')) {
          const ancestorMargin = getComputedMargin(element);
          computedMarginKeys.forEach(key => {
            if (ancestorMargin[key]) {
              computedMargin[key] += ancestorMargin[key];
            }
          });
          addAncestorComputedMargin(element.parentNode);
        }
      };
      addAncestorComputedMargin(dndAreaElement.parentElement);
    }
    return computedMargin;
  }
  return {};
};